var map = {
	"./mountain-badge--dark.svg": 952,
	"./mountain-badge--light.svg": 953,
	"./snow-badge--dark.svg": 954,
	"./snow-badge--light.svg": 955,
	"./tide-badge--dark.svg": 956,
	"./tide-badge--light.svg": 957,
	"./weather-badge--dark.svg": 958,
	"./weather-badge--light.svg": 959
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 951;